import React from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import "./App.css";

const MaintenancePage = () => (
  <div className="maintenance-wrapper" style={{ minHeight: "100vh", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", background: "#f8fafc" }}>
    <h1 style={{ fontSize: "2.5rem", color: "#222", marginBottom: "1.5rem" }}>WinniEats is Down for Maintenance</h1>
    <p style={{ fontSize: "1.25rem", color: "#444", marginBottom: "2rem", maxWidth: 500, textAlign: "center" }}>
      We're making some delicious updates to our site!<br />
      Please check back after <strong>April 2nd, 2025</strong> when we'll be live again with fresh content and new features.<br /><br />
      Thank you for your patience!
    </p>
        <div style={{ color: '#f8fafc', background: '#f8fafc', userSelect: 'text', fontSize: 14, marginTop: 8 }}>
      <span>
        We are currently working on maintenance, but have a dev branch working for the last review at /saperavi ;)
      </span>
    </div>
    <img src="/maintenance.jpg" alt="Maintenance" style={{ maxWidth: 520, width: "100%", marginBottom: "2rem" }} />
    <div style={{ color: "#888", fontSize: "1rem" }}>— Ivan</div>
  </div>
);

const SaperaviPage = () => {
  const [authorized, setAuthorized] = React.useState(false);
  React.useEffect(() => {
    if (!authorized) {
      const pw = window.prompt("Password required to view this page:");
      if (pw && pw.toLowerCase() === "tarragon") {
        setAuthorized(true);
      } else if (pw !== null) {
        alert("Incorrect password. Please try again.");
        window.location.href = "/";
      }
    }
  }, [authorized]);

  if (!authorized) return <div>Reload the page to enter the password.</div>;

  return (
    <div style={{
      background: "#0f0026"
    }}>
      <div style={{
        background: "#0f0026",
        minHeight: "100vh",
        padding: "2rem",
        fontFamily: '"Comic Sans MS", "Papyrus", cursive, fantasy',
        color: "#39ff14",
        maxWidth: 900,
        margin: "0 auto"
      }}>
        <h1 style={{
          fontSize: "3rem",
          color: "#ff00cc",
          textShadow: "2px 2px 8px #00fff7, 0 0 10px #ff00cc",
          fontFamily: 'Impact, "Comic Sans MS", fantasy',
          marginBottom: "1.5rem",
          letterSpacing: "2px"
        }}>
          Saperavi: Authentic Georgian Comfort on Corydon Ave
        </h1>
        <div style={{
          display: "flex",
          alignItems: "flex-start",
          marginBottom: "2rem"
        }}>
          <img src="/exterior.jpg" alt="Saperavi exterior" style={{
            width: 220,
            height: 180,
            objectFit: "cover",
            border: "4px dashed #ff00cc",
            marginRight: "1.5rem",
            boxShadow: "0 0 18px #00fff7"
          }} />
          <div style={{ fontSize: "1.2rem", lineHeight: 1.7, color: "#fff", fontFamily: '"Comic Sans MS", "Papyrus", cursive, fantasy' }}>
            <strong style={{ color: "#39ff14", fontSize: "1.4rem" }}>Address:</strong> <span style={{ color: "#fffb00" }}>709 Corydon Ave, Winnipeg</span><br /><br />
            <span style={{ color: "#ff00cc", fontWeight: "bold" }}>Saperavi</span> is a true gem on Corydon, serving up <span style={{ color: "#39ff14" }}>authentic Georgian cuisine</span> in a warm, inviting setting. The decor is cozy and traditional, with Georgian touches that make you feel like you’ve stepped into Tbilisi itself.<br /><br />
            The moment you walk in, you’re greeted by the aroma of fresh baked khachapuri and the gentle hum of Georgian music. The staff are welcoming and knowledgeable, always ready to recommend a dish or share a story. The patio is a must-visit when the Winnipeg sun is out, but Saperavi truly shines as a refuge from the cold, making it the perfectfor a hearty meal on a winter night.
          </div>
        </div>
        <div style={{
          display: "flex",
          alignItems: "flex-start",
          flexDirection: "row-reverse",
          marginBottom: "2rem"
        }}>
          <img src="/food.jpg" alt="Georgian food" style={{
            width: 220,
            height: 180,
            objectFit: "cover",
            border: "4px dotted #39ff14",
            marginLeft: "1.5rem",
            boxShadow: "0 0 18px #ff00cc"
          }} />
          <div style={{ fontSize: "1.2rem", lineHeight: 1.7, color: "#fff", fontFamily: '"Comic Sans MS", "Papyrus", cursive, fantasy' }}>
            <span style={{ color: "#fffb00", fontWeight: "bold" }}>The Food:</span> <br />
            The <span style={{ color: "#39ff14" }}>khinkali</span> (Georgian dumplings) are plump, juicy, and taste just like the ones you’d find in Tbilisi (pure comfort), especially on a snowy Winnipeg evening. The <span style={{ color: "#ff00cc" }}>khachapuri</span> is a gooey, cheesy masterpiece, baked fresh and served piping hot, you can't miss it!!!<br /><br />
            Now, let’s talk about the <span style={{ color: "#ff00cc" }}>badrijani nigvzit</span> (eggplant rolls). Full disclosure: I, Ivan, am notorious for hating eggplant. I’d sooner eat my own shoe than order it on purpose. But Alex, my ever adventurous dining companion, dove right in and declared them “shockingly good.” I’ll take his word for it, someone has to keep the eggplant economy afloat.<br /><br />
            For mains, the <span style={{ color: "#00fff7" }}>lamb chakapuli</span> is a tangy, herby delight, and every dish is made with care and authenticity, using traditional recipes and spices. Pair it all with a glass of Georgian wine or a classic cocktail from the bar.<br /><br />
            Bonus: We ended up chatting with Pyotr, one of the bartenders, who not only mixed a killer tarragon cocktail but also regaled us with stories of Georgian feasts and Winnipeg winters. By the end of the night, we felt like regulars.
            <div style={{ display: "flex", alignItems: "center", marginTop: "1.5rem", marginBottom: "1.5rem" }}>
              <img src="/bar.jpg" alt="Ivan, Alex, and Pyotr at Saperavi" style={{
                width: 180,
                height: 140,
                objectFit: "cover",
                border: "3px solid #ff00cc",
                borderRadius: 10,
                marginRight: "1.2rem",
                boxShadow: "0 0 12px #00fff7"
              }} />
              <span style={{ color: "#fffb00", fontSize: "1.1rem", fontFamily: '"Comic Sans MS", "Papyrus", cursive, fantasy' }}>
                Ivan, Alex, and Pyotr (the legend himself) after a round of tarragon cocktails.
              </span>
            </div>
          </div>
        </div>
        <div style={{
          background: "#1a0033",
          border: "3px solid #fffb00",
          borderRadius: 12,
          padding: "1.5rem",
          marginBottom: "2rem",
          color: "#fffb00",
          fontFamily: '"Papyrus", "Comic Sans MS", cursive, fantasy',
          fontSize: "1.15rem",
          boxShadow: "0 0 18px #39ff14"
        }}>
          <strong>Authenticity & Comfort:</strong> Saperavi’s decor is warm and authentic, with Georgian art and details throughout. It’s the kind of place you want to settle into on a cold winter night, with a hearty meal and good company.<br /><br />
    <strong>Final Verdict:</strong> Saperavi is a must visit for anyone craving genuine Georgian food in Winnipeg. Come for the khachapuri, stay for the hospitality (and maybe say hi to Pyotr for us <strong>or say high to him at his local pop up, 'Dirt Cheap Drinks' at 520 Osborne St</strong>). <span style={{ color: "#ff00cc" }}>10/10 for authenticity, comfort, and sassy eggplant avoidance—perfect for Winnipeg winters!</span>
        </div>
        <div style={{ textAlign: "center", marginTop: 32 }}>
          <span style={{ fontFamily: 'Impact, fantasy', color: "#ff00cc", fontSize: "2rem", textShadow: "0 0 8px #39ff14" }}>
            <marquee behavior="alternate" scrollamount="8">Saperavi: A Taste of Georgia!</marquee>
          </span>
        </div>
      </div>
    </div>
  );
};

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<MaintenancePage />} />
        <Route path="/saperavi" element={<SaperaviPage />} />
      </Routes>
    </Router>
  );
};

export default App;
